// @ts-nocheck
import { getDomainConfig, getLocale, hasEtfConfiguratorProducts, hasPPProducts, isDistributorCustomer, LINKS, PP_LINKS as PENSION_PRODUCTS_LINKS, visitDashboard, } from '@raisin/cp-utils';
import { hasCryptoPortfolio } from '../../../../utils/helpers/index';
import { getCockpitURL, getSavingglobalUrl } from '../utils';
export const HAS_FIXED_DEPOSIT_ACCOUNT = 'HAS_FIXED_DEPOSIT_ACCOUNT';
export const HAS_FLEX_DEPOSIT_ACCOUNT = 'HAS_FLEX_DEPOSIT_ACCOUNT';
export const HAS_INVESTMENT_PRODUCT_ACCOUNT = 'HAS_INVESTMENT_PRODUCT_ACCOUNT';
export const HAS_NOTICE_DEPOSIT_ACCOUNT = 'HAS_NOTICE_DEPOSIT_ACCOUNT';
export const HAS_OVERNIGHT_DEPOSIT_ACCOUNT = 'HAS_OVERNIGHT_DEPOSIT_ACCOUNT';
export const getDeMenus = ({ customer, productAccess, pensionProductsData, hasDWMProduct, hasMigratedRobo, pomProducts, productsTypes, b2cUseNewDashboard, dbtShowNewMyDepositsPage, }) => {
    const { isCompanyCustomer } = customer || {};
    const localeCmsFormat = getLocale('de-DE').cmsFormat;
    const basePath = getDomainConfig(localeCmsFormat).basePath;
    const dashboardUrl = visitDashboard(b2cUseNewDashboard, true);
    const myInvestments = {
        id: 'myInvestments',
        title: 'Meine Anlagen',
        href: '',
        subMenus: {
            layout: 'even',
            top: [
                {
                    id: 'dashboard-myInvestments',
                    type: 'basic',
                    title: 'Übersicht',
                    href: dashboardUrl,
                    icon: 'overviewIcon',
                    iconColor: '#0E6CC5',
                },
            ],
            main: [
                productAccess.includes(HAS_OVERNIGHT_DEPOSIT_ACCOUNT) && {
                    id: 'overnight-deposit',
                    type: 'basic',
                    title: 'Tagesgeld',
                    href: dbtShowNewMyDepositsPage
                        ? basePath + LINKS.DASHBOARD.DEPOSIT_PAGES.OVERNIGHT
                        : getSavingglobalUrl('/#/MyInvestments/Overnight', localeCmsFormat),
                    icon: 'overnightMoneyIcon',
                    iconColor: '#9CD3E4',
                    groupName: 'Sparen',
                },
                (productAccess.includes(HAS_FIXED_DEPOSIT_ACCOUNT) ||
                    productAccess.includes(HAS_FLEX_DEPOSIT_ACCOUNT)) && {
                    id: 'fixed-deposit',
                    type: 'basic',
                    title: 'Festgeld',
                    href: dbtShowNewMyDepositsPage
                        ? basePath + LINKS.DASHBOARD.DEPOSIT_PAGES.TERM
                        : getSavingglobalUrl('/#/MyInvestments/TermDeposit', localeCmsFormat),
                    icon: 'fixedDepositIcon',
                    iconColor: '#61AFD2',
                    groupName: 'Sparen',
                },
                productAccess.includes(HAS_NOTICE_DEPOSIT_ACCOUNT) && {
                    id: 'noticeDeposit-offers',
                    type: 'basic',
                    title: 'Kündigungsgeld',
                    href: dbtShowNewMyDepositsPage
                        ? basePath + LINKS.DASHBOARD.DEPOSIT_PAGES.NOTICE
                        : getSavingglobalUrl('/#/MyInvestments/Notice', localeCmsFormat),
                    icon: 'terminationPaymentIcon',
                    iconColor: '#317EA6',
                    groupName: 'Sparen',
                },
            ],
            sidebar: [
                (hasDWMProduct || hasMigratedRobo) && {
                    id: 'investment-products-DWM',
                    type: 'basic',
                    title: hasMigratedRobo ? 'ETF Robo' : 'Vermögensverwaltung',
                    href: getCockpitURL('?ref=header'),
                    icon: 'etfRoboIcon',
                    iconColor: '#FBC02D',
                    groupName: 'Investieren',
                },
                hasEtfConfiguratorProducts(pensionProductsData) && {
                    id: 'investment-products-configurator',
                    type: 'basic',
                    title: 'ETF Configurator',
                    href: PENSION_PRODUCTS_LINKS.etfcCockpitMigrated,
                    icon: 'etfConfiguratorIcon',
                    iconColor: '#FFA300',
                    groupName: 'Investieren',
                },
                hasCryptoPortfolio(pensionProductsData) && {
                    id: 'crypto',
                    type: 'basic',
                    title: 'Crypto',
                    href: PENSION_PRODUCTS_LINKS.cryptoMigrated,
                    icon: 'cryptoIcon',
                    iconColor: '#C72323',
                    groupName: 'Investieren',
                },
                hasPPProducts(pensionProductsData) && {
                    id: 'raisin-pension',
                    type: 'basic',
                    title: 'Pension',
                    href: PENSION_PRODUCTS_LINKS.pensionCockpitMigrated,
                    icon: 'etfRurupIcon',
                    iconColor: '#AEC962',
                    groupName: 'Investieren',
                },
            ],
        },
    };
    const offers = {
        id: 'offers',
        title: 'Angebote',
        href: '',
        subMenus: {
            layout: 'even',
            main: [
                (productsTypes === null || productsTypes === void 0 ? void 0 : productsTypes.overnight_product_access) && {
                    id: 'overnightDeposit-offers',
                    type: 'advanced',
                    title: 'Tagesgeld',
                    href: `${basePath}/products/overnight/`,
                    description: 'Flexible Anlage ohne festgelegte Laufzeit und mit variablem Zins',
                    icon: 'overnightMoneyIcon',
                    iconColor: '#9CD3E4',
                    groupName: 'Sparen',
                },
                (productsTypes === null || productsTypes === void 0 ? void 0 : productsTypes.term_product_access) && {
                    id: 'fixedDeposit-offers',
                    type: 'advanced',
                    title: 'Festgeld',
                    href: `${basePath}/products/`,
                    description: 'Termineinlage mit fester Laufzeit und festem Zins',
                    icon: 'fixedDepositIcon',
                    iconColor: '#61AFD2',
                    groupName: 'Sparen',
                },
                {
                    id: 'sustainable-products',
                    type: 'advanced',
                    title: 'Nachhaltiges Festgeld',
                    href: `${basePath}/festgeld/nachhaltig/`,
                    description: 'Einlagen mit festem Zinssatz, die in verantwortungsvolle Projekte fließen',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt219a2d014c4f51f6/sustainable-deposit-badge-green.svg',
                    iconColor: '#9CD3E4',
                    groupName: 'Sparen',
                },
                (productsTypes === null || productsTypes === void 0 ? void 0 : productsTypes.notice_product_access) && {
                    id: 'noticeDeposit-offers',
                    type: 'advanced',
                    title: 'Kündigungsgeld',
                    href: `${basePath}/products/notice/`,
                    description: 'Einlage ohne feste Laufzeit mit variablem Zins und Kündigungsfrist',
                    icon: 'terminationPaymentIcon',
                    iconColor: '#317EA6',
                    groupName: 'Sparen',
                },
                {
                    id: 'money-market',
                    type: 'advanced',
                    title: 'Zinsportfolio',
                    href: `${basePath}/zinsportfolio/`,
                    description: 'Flexibel sparen am Geldmarkt mit Zinsoptimierung',
                    icon: 'etfRoboIcon',
                    iconColor: '#FBC02D',
                    groupName: 'Sparen',
                },
            ],
            sidebar: [
                (pomProducts === null || pomProducts === void 0 ? void 0 : pomProducts.dwm) && {
                    id: 'DWM-advisor-offers',
                    type: 'advanced',
                    title: 'Vermögensverwaltung',
                    href: `${basePath}/vermoegensverwaltung/`,
                    description: 'Automatisiert in ein von Experten entwickeltes, globales Portfolio investieren',
                    icon: 'etfRoboIcon',
                    iconColor: '#FBC02D',
                    groupName: 'Investieren',
                },
                (pomProducts === null || pomProducts === void 0 ? void 0 : pomProducts.pension) && {
                    id: '8f49f12f-8b42-4404-a9e1-a8af52d340a5',
                    type: 'advanced',
                    title: 'ETF Rürup',
                    href: 'https://www.raisin-pension.de/',
                    description: 'Mit Steuervorteilen für das Alter vorsorgen',
                    icon: 'etfRurupIcon',
                    iconColor: '#AEC962',
                    groupName: 'Investieren',
                },
            ],
        },
    };
    const finance = {
        id: 'finance',
        title: 'Finanzwissen',
        href: '',
        subMenus: {
            main: [
                {
                    id: 'savings-finance',
                    type: 'advanced',
                    title: 'Sparen',
                    href: `${basePath}/sparen/`,
                    description: 'Höhere Zinsen als bei der Hausbank erhalten, mit nationaler Einlagensicherung',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltf266390c18780027/Sparen.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: 'investments-finance',
                    type: 'advanced',
                    title: 'Geldanlage',
                    href: `${basePath}/geldanlage/`,
                    description: 'Wertschwankungen in Kauf nehmen, um langfristig höhere Renditen zu realisieren',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt928de307dda49550/Geldanlage.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: 'sustainable-products-finance',
                    type: 'advanced',
                    title: 'Nachhaltige Geldanlage',
                    href: `${basePath}/nachhaltige-geldanlage/`,
                    description: 'Von langfristigen Wachstumschancen profitieren, die auf nachhaltigen Standards basieren',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte38c0dd9a50682c2/sustainable-deposit-badge-blue.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: 'tax-information-finance',
                    type: 'advanced',
                    title: 'Steuerinformationen',
                    href: `${isCompanyCustomer ? `${basePath}/geschaeftskunden/steuern/` : `${basePath}/steuern/`}`,
                    description: 'Informationen zur steuerlichen Behandlung von Geldanlagen',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt36b69e61c2b0a979/Steuerinformation.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: 'insurance-deposit-finance',
                    type: 'advanced',
                    title: 'Einlagensicherung',
                    href: `${isCompanyCustomer
                        ? `${basePath}/geschaeftskunden/einlagensicherung/`
                        : `${basePath}/einlagensicherung/`}`,
                    description: 'Alles zum harmonisierten Einlagensicherungssystem in Europa',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltdc24d5d258f982e7/Einlagensicherung.svg',
                    iconColor: '#0E6CC5',
                },
            ],
            sidebar: [
                {
                    id: 'investmentAbroad-finance',
                    type: 'image',
                    title: 'Geldanlagen im Ausland',
                    href: `${basePath}/geldanlage/ausland/`,
                    imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt2583321398710b00/Image_Ausland.png',
                    description: 'Geldanlagen im Ausland',
                },
                {
                    id: 'differenceFundsEtfs-finance',
                    type: 'arrow',
                    title: 'Unterschied Fonds ETFs',
                    href: `${basePath}/geldanlage/etf/unterschied-fonds-etf/`,
                },
                {
                    id: 'b8401a9d-2cfb-4280-b7ad-d54ee8c31d7e',
                    type: 'arrow',
                    title: 'Steuern sparen',
                    href: `${basePath}/steuer/steuern-sparen/`,
                },
                {
                    id: '5330f3cf-1ecb-4689-b50f-83ca4fa184e8',
                    type: 'arrow',
                    title: 'Was bedeutet AWV-Meldepflicht?',
                    href: `${basePath}/faq/bedeutet-awv-meldepflicht/`,
                },
                {
                    id: 'e776ab43-cce8-4cb1-9660-f10521d72350',
                    type: 'arrow',
                    title: 'Was ist die Quellensteuer?',
                    href: `${basePath}/steuer/quellensteuer/`,
                },
            ],
        },
    };
    const help = {
        id: '2e11a01f-4216-4fea-b05f-2fd46cf3a8b4',
        title: 'Hilfe',
        href: '',
        subMenus: {
            main: [
                {
                    id: 'a9cbf2ad-81bc-4f83-8196-b67b414f9b0f',
                    type: 'text',
                    title: 'So funktioniert’s',
                    href: `${basePath}/so-funktionierts/`,
                },
                {
                    id: '9a91930e-db2a-45be-8eab-30a081e40e03',
                    type: 'text',
                    title: 'Banken',
                    href: `${basePath}/bank/`,
                },
                {
                    id: 'c3f65470-a71c-4079-adae-a644c03c00a2',
                    type: 'text',
                    title: 'Häufig gestellte Fragen',
                    href: 'https://kundenservice.weltsparen.de/hc/de/',
                },
                {
                    id: '457a0585-4847-4c2c-bbad-620101e9512b',
                    type: 'text',
                    title: 'Kundenservice',
                    href: `${basePath}/kontakt/`,
                },
            ],
        },
    };
    let navItems = [myInvestments, offers];
    if (!isDistributorCustomer(customer.distributorId)) {
        navItems = [...navItems, finance];
    }
    return [...navItems, help];
};
//# sourceMappingURL=deMenus.js.map